import "./DiscountsReport.scss";

import React from "react";
import usesFeatures from "usesFeatures";

import Table from "Table";
import Header from "Header";
import Paginate from "Paginate";
import BaseReport from "VenueAdmin/shared/BaseReport";
import ReportFilters from "VenueAdmin/shared/ReportFilters";

class DiscountsReport extends BaseReport {
  getBaseEndpoint() {
    return "venue_admin/discounts_report";
  }

  getSearchEndpoint() {
    return "venue_admin/discounts_report/search_discounts";
  }

  getDownloadFilename() {
    return `Discounts Report - ${new Date().toISOString().split('T')[0]}.csv`;
  }

  getItemIdsParamName() {
    return "discount_ids";
  }

  getItemsDataKey() {
    return "discounts";
  }

  itemFormatters = () => ({
    storeName: (item) => item.storeName,
    discountName: (item) => item.discountName,
    discountAmount: (item) => item.discountAmount,
    averageAmount: (item) => item.averageAmount,
    quantityApplied: (item) => item.quantityApplied,
    orderCount: (item) => item.orderCount,
    total: (item) => item.total,
  });

  renderFilters() {
    const { filters, selectedItems, itemSearch, itemSuggestions, showSuggestions } = this.state;
    const stores = this.props.stores || [];

    return (
      <ReportFilters
        filters={filters}
        stores={stores}
        selectedItems={selectedItems}
        itemSearch={itemSearch}
        itemSuggestions={itemSuggestions}
        showSuggestions={showSuggestions}
        itemLabel="Discounts"
        itemPlaceholder="Search discounts..."
        onFilterChange={this.handleFilterChange}
        onItemSearchChange={this.handleItemSearchChange}
        onItemSelect={this.selectItem}
        onItemRemove={this.removeItem}
        onClearAllItems={this.clearAllItems}
        onFocus={() => itemSuggestions.length > 0 && this.setState({ showSuggestions: true })}
        onBlur={() => setTimeout(() => this.setState({ showSuggestions: false }), 200)}
      />
    );
  }

  render() {
    if (!this.props.dataFetched) return false;

    return (
      <div className="DiscountsReport">
        <Header text="Discounts Report" actions={true}>
          <button
            className="button is-primary"
            onClick={this.handleDownload}
            disabled={this.state.downloading}
          >
            {this.state.downloading ? 'Downloading...' : 'Download CSV'}
          </button>
        </Header>

        {this.renderFilters()}

        <Table
          showHeader={true}
          headers={DISCOUNT_HEADERS}
          formatters={this.itemFormatters()}
          rows={this.props.pageData || []}
          empty="No discounts found for the selected filters"
        />

        {this.props.grandTotal && (
          <div className="total-row">
            <strong>Total: {this.props.grandTotal}</strong>
          </div>
        )}

        <Paginate changePage={this.changePage} {...this.props.pagy} />
      </div>
    );
  }
}

const DISCOUNT_HEADERS = {
  storeName: "Store",
  discountName: "Name",
  discountAmount: "Discount",
  averageAmount: "Avg Amount",
  quantityApplied: "Qty Applied",
  orderCount: "Orders",
  total: "Total",
};

export default usesFeatures(["data", "pagination"], DiscountsReport);
